import { BillingModel } from '@/Enums/BillingModel.enum';

export default class BillingModelService {
  public static isRateCard(billingModel: BillingModel | null): boolean {
    return billingModel === BillingModel.RATE_CARD;
  }
  public static isPercentOfMedia(billingModel: BillingModel | null): boolean {
    return billingModel === BillingModel.PERCENT_OF_MEDIA;
  }

  public static allowPublisherSelection(billingModel: BillingModel | null): boolean {
    return this.isPercentOfMedia(billingModel);
  }

  public static allowDeviceSelection(billingModel: BillingModel | null): boolean {
    return this.isPercentOfMedia(billingModel);
  }

  public static allowBidCpmControl(billingModel: BillingModel | null): boolean {
    return this.isPercentOfMedia(billingModel);
  }

  public static allowRateCardCpmControl(billingModel: BillingModel | null): boolean {
    return this.isRateCard(billingModel);
  }
}
